import React from 'react';
import { Search } from 'lucide-react';
import { useTenant } from '../../contexts/TenantContext';
import { partyNoun } from '../../utils/tenantProfile';

const ClientFilters = ({ filters, onFiltersChange }) => {
  const { tenant } = useTenant();
  const party = partyNoun(tenant);
  const handleChange = (e) => {
    onFiltersChange({
      ...filters,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
      <div className="relative">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
        <input
          type="text"
          name="search"
          placeholder={`Buscar ${party.many}...`}
          value={filters.search}
          onChange={handleChange}
          className="form-input pl-10"
        />
      </div>
      <div>
        <select name="status" value={filters.status} onChange={handleChange} className="form-select">
          <option value="">Todos os Status</option>
          <option value="ACTIVE">Ativo</option>
          <option value="INACTIVE">Inativo</option>
        </select>
      </div>
      <div>
        <select name="type" value={filters.type} onChange={handleChange} className="form-select">
          <option value="">Todos os Tipos</option>
          <option value="INDIVIDUAL">Pessoa Física</option>
          <option value="LEGAL_ENTITY">Pessoa Jurídica</option>
        </select>
      </div>
      <div>
        <select name="sortBy" value={filters.sortBy} onChange={handleChange} className="form-select">
          <option value="name">Ordenar por Nome</option>
          <option value="document">Ordenar por Documento</option>
        </select>
      </div>
    </div>
  );
};

export default ClientFilters;